import { Component, Input } from '@angular/core';
import { DictionaryRequestStatus } from 'src/app/extensions/constants/dictionaryConstants/dictionaryConstants';

@Component({
  selector: 'request-list-view',
  templateUrl: './request-list-view.component.html',
  styleUrls: ['./request-list-view.component.scss'],
  standalone: false,
})
export class RequestListViewComponent {
  public dictionaryRequestStatus = DictionaryRequestStatus;

  @Input() public requests: app.models.RequestListModel[];
  @Input() public props: app.models.DynamicPropsDictionary;
  @Input() public viewDetails: any;
}
